import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupLiveOddsByName',
})
export class GroupLiveOddsByName implements PipeTransform {
  transform(value): any {
    const groups = {};
    if (value != null)
      if (value.length > 0) {
        value.forEach(function (o) {
          //var groupName = o.OddType;
          const groupName = o.OddType + o.SpecialBetValue;
          const sbv = o.SpecialBetValue;
          const seqNum = o.SeqNumber;
          const OddTypeId = o.OddTypeId;
          groups[groupName] = groups[groupName] ? groups[groupName] : { OddTypeId: OddTypeId, GroupName: groupName, seq: seqNum, sbv: sbv, eOdds: [] };
          groups[groupName].eOdds.push(o);
        });
      }
    return Object.keys(groups).map(function (key) {
      return groups[key];
    });
  }
}
